import { reducerWithInitialState } from "typescript-fsa-reducers";

import withImmer from "../../lib/withImmer";
import { Modal, modalOpened, modalClosed } from "../actions/Modal";

export interface ModalsState {
  currentModal: Modal | null;
}

const initialState: ModalsState = {
  currentModal: null,
};

const modalsReducer = withImmer(reducerWithInitialState(initialState))
  .case(modalOpened, (state, action) => {
    state.currentModal = action;
    return state;
  })
  .case(modalClosed, (state, action) => {
    const isCurrentModal =
      state.currentModal && action.name === state.currentModal.name && action.id === state.currentModal.id;
    state.currentModal = isCurrentModal ? null : state.currentModal;
    return state;
  });

export default modalsReducer;



// WEBPACK FOOTER //
// ./frontend/src/common/reducers/modals.ts